import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './crisis/HeroSection';
import { MainContentSection } from './crisis/MainContentSection';
export function CrisisManagementPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-517">
      <Navbar data-id="element-518" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-519">
        <HeroSection data-id="element-520" />
        <MainContentSection data-id="element-521" />
      </main>
      <Footer data-id="element-522" />
    </div>;
}